export default {
  snackbar: state => state.snackbar,
};



// WEBPACK FOOTER //
// ./src/store/app/getters.js